export class SortInfo {
    SortColumn: string = '';
    sortDirection: string = '';
}
